import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import { useCopilot } from 'shared/context/CopilotContext';
import { getActionDetailContent } from 'shared/copilot/toolRegistryPreviews';
import { isRecord } from 'shared/copilot/toolRegistry/parsing';
interface CopilotActionDetailProps {
  toolName: string;
  args: unknown;
}

/**
 * Renders action detail at display time so page-specific label resolvers
 * (e.g. translated metric names) from CopilotContext are available.
 */
const CopilotActionDetail = t0 => {
  const $ = _c(6);
  const {
    toolName,
    args
  } = t0;
  const {
    actionDisplayResolvers
  } = useCopilot();
  const t1 = isRecord(args) ? args : undefined;
  let t2;
  if ($[0] !== actionDisplayResolvers || $[1] !== t1 || $[2] !== toolName) {
    t2 = getActionDetailContent(toolName, t1, actionDisplayResolvers);
    $[0] = actionDisplayResolvers;
    $[1] = t1;
    $[2] = toolName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <>{t2}</>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default CopilotActionDetail;